/** Preferred work locations — multi-value field (like skills). */

export function normalizePreferredWorkLocations(candidateOrForm) {
  const src = candidateOrForm || {};
  if (Array.isArray(src.preferredWorkLocations)) {
    return [...new Set(src.preferredWorkLocations.map(s => String(s).trim()).filter(Boolean))];
  }
  const legacy = src.location;
  if (typeof legacy === 'string' && legacy.trim()) {
    return [...new Set(legacy.split(',').map(s => s.trim()).filter(Boolean))];
  }
  return [];
}

export function preferredWorkLocationsToLegacyLocation(locations) {
  return (locations || []).filter(Boolean).join(', ');
}

export function mergeLocationCatalog(...sources) {
  const set = new Set();
  for (const list of sources) {
    for (const item of list || []) {
      const s = String(item ?? '').trim();
      if (s && s !== '—') set.add(s);
    }
  }
  return [...set].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}
